module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.859c33e6.svg";